import React, { useEffect } from 'react';

import {
	Button,
	Card,
	Checkbox,
	Col,
	Form,
	Input,
	Row,
	Typography,
	message,
} from 'antd';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

import { svBaseGoApiClient } from '@/api/batch_process';
import client from '@/lib/http/client';

import style from './style.module.css';

import logo from './logo.webp';

// ...

const Login = () => {
	const location = useLocation();
	const userEmail = location.state?.email || '';
	const [form] = Form.useForm();
	const [loading, setLoading] = React.useState(false);
	const navigate = useNavigate();
	useEffect(() => {
		if (userEmail) {
			form.setFieldsValue({
				email: userEmail,
			});
		}
	}, [userEmail]);

	useEffect(() => {
		form.setFieldValue('remember', true);
	}, []);

	return (
		<Card
			title={
				<div className={style.wrapper}>
					<div className={style.logo}>
						<img src={logo} alt="" />
					</div>
					<div className={style.title}>
						<h2>Login</h2>
					</div>
				</div>
			}
			hoverable
			style={{ minWidth: '428px' }}
		>
			<Form
				layout="vertical"
				form={form}
				onFinish={(values) => {
					setLoading(true);
					client
						.post('/auth/login', values)
						.then((res) => {
							if (res?.data) {
								typeof res?.data?.isSpecialUICondition === 'boolean' &&
									localStorage.setItem(
										'sv_is_special_condition',
										res?.data?.isSpecialUICondition ? '1' : '0',
									);
								typeof res?.data?.canUserArchiveCopilotPosts === 'boolean' &&
									localStorage.setItem(
										'sv_can_user_archive_copilot_posts',
										res?.data?.canUserArchiveCopilotPosts ? '1' : '0',
									);
							}

							const previousPage = localStorage.getItem('previousPage');

							svBaseGoApiClient
								.post('/login', values)
								.then((res) => {
									if (res?.data?.token) {
										localStorage.setItem('sv_go_key', res?.data?.token);
									}
								})
								.catch((err) => {
									console.log('err login go api', err);
								});

							console.log('previousPage', previousPage);

							navigate(
								previousPage
									? previousPage
									: '/app/dashboard/product-main-menu',
							);
						})
						.catch((err: any) => {
							setLoading(false);
							console.log(err);

							if (err.response?.data?.message === 'Access denied') {
								return message.error('Access denied');
							}

							if (
								err.response?.data.message === 'Unauthorized' ||
								err.response?.data.message === 'Incorrect credentials' ||
								err.response?.data.message === 'login required'
							) {
								form.setFields([
									{
										name: 'email',
										errors: ['Email or password is incorrect'],
									},
									{
										name: 'password',
										errors: ['Email or password is incorrect'],
									},
								]);
							} else {
								message.error(
									`An error occured: ${
										err?.response?.data?.message || err?.message
									}.`,
								);
							}
						});
				}}
			>
				<Form.Item
					label="Email"
					name="email"
					rules={[
						{
							required: true,
							message: 'Email is required',
						},
					]}
				>
					<Input placeholder="" defaultValue={userEmail} type="email" />
				</Form.Item>

				<Form.Item
					label="Password"
					name="password"
					rules={[{ required: true, message: 'Password is required' }]}
				>
					<Input.Password />
				</Form.Item>

				<Form.Item label="" name="remember" valuePropName="checked">
					<Checkbox name="remember">Remember me</Checkbox>
				</Form.Item>

				<Form.Item>
					<Button type="primary" htmlType="submit" block loading={loading}>
						Login
					</Button>
				</Form.Item>

				<Form.Item style={{ textAlign: 'center' }}>
					{/* TODO register link */}
					<Typography.Text>
						Don't have an account?{' '}
						<Typography.Link onClick={() => navigate('/auth/register')}>
							{' '}
							Register here
						</Typography.Link>
					</Typography.Text>
				</Form.Item>
				<Form.Item style={{ textAlign: 'center' }}>
					<Typography.Text>
						<Typography.Link onClick={() => navigate('/auth/reset-password')}>
							Forgot password?
						</Typography.Link>
					</Typography.Text>
				</Form.Item>
			</Form>
		</Card>
	);
};

export default Login;
